import { Injectable } from '@angular/core';

/**
 * Service d'accessibilité RGAA pour le contenu HTML généré par Strapi.
 *
 * Ce service applique les corrections d'accessibilité nécessaires sur le contenu
 * injecté via [innerHTML] depuis Strapi, qui ne peut pas être modifié directement
 * dans les templates Angular.
 *
 * Critères RGAA traités :
 * - 5.3 : Les tableaux de mise en page (figure.table > table) reçoivent
 *         role="presentation" pour ne pas être annoncés comme tableaux de données
 *         par les lecteurs d'écran.
 */
@Injectable({
  providedIn: 'root'
})
export class StrapiContentAccessibilityService {

  /**
   * Applique les attributs d'accessibilité RGAA sur le contenu généré par Strapi.
   *
   * @param containerElement L'élément DOM contenant le contenu HTML à traiter
   * @returns true si au moins une modification a été effectuée, false sinon
   */
  public applyAccessibilityFixes(containerElement: HTMLElement): boolean {
    if (!containerElement) return false;

    let hasAppliedSomething = false;

    // RGAA 5.3 — Tableaux de mise en page
    // Les <table> enfants directs de <figure class="table"> sont des tableaux de
    // mise en page générés par CKEditor/Strapi. Ils doivent avoir role="presentation"
    // pour être ignorés par les lecteurs d'écran.
    const layoutTables = containerElement.querySelectorAll('figure.table > table');
    layoutTables.forEach((table) => {
      if (!table.hasAttribute('role')) {
        table.setAttribute('role', 'presentation');
        hasAppliedSomething = true;
      }
    });

    return hasAppliedSomething;
  }
}
